import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataManipulationService } from 'src/app/services/data-manipulation.service';

interface CodexReport {
  uuid: string,
  name: string,
  index: number,
  team: any,
  score: {
    value: number,
    trend: any,
    color: string,
    diff: {
      value: number,
      trend: any
    }
  },
  highestTopic: any,
  lowestTopic: any
}

@Component({
  selector: 'app-team-leadership-codex',
  templateUrl: './team-leadership-codex.component.html',
  styleUrls: ['./team-leadership-codex.component.scss']
})
export class TeamLeadershipCodexComponent implements OnInit {

  @Input() set codexReports(value: any) {
    this.teamCodexReports = value;
    this.sortCurrentAndPreviousReport(0);
  }
  @Input() isUserEligibleToSeeMore!: boolean;

  @Output() seeMoreTeamCodex = new EventEmitter<any>();

  currentReport: any;
  previousReport: any;

  scoreColor: string = '#A0ADCE';

  teamCodexReports: any[] = [];

  constructor(private data: DataManipulationService) { }

  ngOnInit(): void {
  }

  sortCurrentAndPreviousReport(index: number) {
    if (this.teamCodexReports[index]) {
      this.currentReport = this.setCurrentReportData(this.teamCodexReports[index], this.teamCodexReports[index+1]);
    }
    if (this.teamCodexReports[index + 1]) {
      this.previousReport = this.teamCodexReports[index + 1];
    } else {
      this.previousReport = null;
    }
  }

  setCurrentReportData(currentReport: any, previousReport: any): CodexReport {
    const {highest, lowest} = this.sortTopics(currentReport.details);
    const {highest: prevHighest, lowest: prevLowest} = previousReport ? this.sortTopics(previousReport.details): {highest: null, lowest: null};
    return {
      uuid: currentReport.uuid,
      name: currentReport.quarter,
      index: currentReport.index,
      team: currentReport.team,
      highestTopic: {
        ...highest,
        comparison: this.compareTopics(highest, prevHighest),
        //@ts-ignore
        gradientColor: this.data.colors[`${highest.color}Gradient`]
      },
      lowestTopic: {
        ...lowest,
        comparison: this.compareTopics(lowest, prevLowest),
        //@ts-ignore
        gradientColor: this.data.colors[`${lowest.color}Gradient`]
      },
      score: {
        value: currentReport.score.value,
        trend: previousReport ? this.getTrendBasedOnScores(currentReport.score.value, previousReport.score.value) : null,
        //@ts-ignore
        color: this.data.colors[currentReport.score.color],
        diff: {
          value: previousReport ? Math.round(currentReport.score.value - previousReport.score.value) : 0,
          trend: previousReport ? ((currentReport.score.value - previousReport.score.value) > 0 ? 'up' : 'down') : null
        }
      }
    }
  }

  sortTopics(topics: any) {
    if (!topics?.length) return { highest: null, lowest: null };

    return topics.reduce((acc: any, topic: any) => {
      if (topic.score > acc.highest.score) acc.highest = topic;
      if (topic.score < acc.lowest.score) acc.lowest = topic;
      return acc;
    }, {
      highest: topics[0],
      lowest: topics[0]
    });
  }

  compareTopics(current: any, previous: any) {
    if (!current || !previous) {
      return {
        value: current?.score ?? null,
        diff: 0,
        trend: null
      };
    }

    const diff = current.score - previous.score;

    return {
      value: current.score,
      diff: Math.round(diff),
      trend: diff > 0 ? 'up' : diff < 0 ? 'down' : null
    };
  }

  getTrendBasedOnScores(currentScore: number, previousScore: number): string {
    return currentScore > previousScore ? 'up' : 'down';
  }

  seeMore() {
    this.seeMoreTeamCodex.emit();
  }

}
